/* eslint-disable no-unused-vars */
import ApiService from "../../api.service";
import appConfig from "../../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ProductFilterGroupService = {
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async saveProductFilterGroup(payload) {
    const url = `api/Save_ProductFilterGroup`;
    if (!payload.Code) return await ApiService.post(url, payload);
    else ApiService.put(url, payload.Code, payload, "Integer");
  },

  async getProductFilterGroupByCode(code) {
    const requestScreenData = {
      url: "api/ProductFilterGroup",
      top: "1",
      filter: `Code eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getProductFilterGroupCustomersByCode(code) {
    const requestScreenData = {
      url: "api/ProductFilterGroupCustomerList",
      filter: `ProductFilterGroupCode eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getProductFilterGroupProductsByCode(code) {
    const requestScreenData = {
      url: "api/ProductFilterGroupProductList",
      filter: `ProductFilterGroupCode eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { ProductFilterGroupService };
